<template>
<div id="container">
   <div class="locationWrap about">
     <div>
       <span class="inner aniBox type_right gogo"><span>D</span>ata <br><span>A</span>nalysis <br><span>M</span>arketplace for <br><span>D</span>ata<br><span>A</span>lliance</span>
       <strong class="inner locTit aniBox type_bot gogo">
         <p class="">데이터로 가치를 담다. 혁신을 담다. 비전을 담다.</p>DAMDA 소개
       </strong>
     </div>
   </div>
   <div class="contents" >
     <div class="inner">
       <div class="subTitWrap aniBox type_left gogo">
         <h2>빅데이터 플랫폼</h2>
       </div>

       <div class="mcSec con_bigdata_01" id="about0101">
         <div class="inner">
           <div class="mainTit aniBox type_bot gogo">
             <h2>목표</h2>
             <p>데이터 기반 IoT가전 · 전자산업 혁신과 성장을 위한 기업 생태계 조성</p>
           </div>
           <div class="con_bigdata_01_icon  aniBox type_bot gogo">
             <div class="item_1">
               <div class="icon_box"></div>
               <p>IoT제품 新가치 창출</p>
             </div>
             <div class="item_2">
               <div class="icon_box"></div>
               <p>IoT제품 시장 활성화</p>
             </div>
             <div class="item_3">
               <div class="icon_box"></div>
               <p>IoT제품 수출 증대</p>
             </div>
           </div>
         </div>
       </div>
     </div>

     <div class="mcSec con_bigdata_02" id="about0102">
       <div class="inner">
         <div class="mainTit aniBox type_bot gogo">
           <h2>방향 및 추진전략</h2>
           <p>빅데이터 공동플랫폼을 활용하여,<br><strong>데이터 기반 가전산업의 지속 가능한 성장기반을 마련</strong>하고 빅데이터를 활용한 새로운 서비스 시장이 창출되도록 상시지원체계 구축</p>
         </div>
         <div class="con_bigdata_02_icon aniBox type_bot gogo">
           <div class="item_1">
             <div class="icon_box"></div>
             <dl>
               <dt>기업 데이터 기반 강화</dt>
               <dd>IoT제품에 데이터 기반 서비스가 결합되어 새로운 고객 가치를 창출하도록 경험 내재화</dd>
             </dl>
           </div>
           <div class="item_2">
             <div class="icon_box"></div>
             <dl>
               <dt>데이터 협업 생태계 조성</dt>
               <dd>수집데이터의 분석·활용으로 제품별, 서비스별 다양한 융합이 촉진되어 기업(간) 비즈니스 혁신</dd>
             </dl>
           </div>
           <div class="item_3">
             <div class="icon_box"></div>
             <dl>
               <dt>수출제품 위기상황 대응</dt>
               <dd>국가별, 지역별 다양한 개인 정보보호 규제를 제품 개발 단계에 반영하여 위기상황 사전 대응</dd>
             </dl>
           </div>
         </div>
       </div>
     </div>

     <div class="inner mcSec con_bigdata_03" id="about0103">
       <div class="mainTit aniBox type_bot gogo">
         <h2>사업범위</h2>
       </div>
       <div class="con_bigdata_03_wrap">
         <ul class="con_bigdata_03_list col3">
           <li class="col_item aniBox type_bot gogo con01">
             <p>플랫폼 구축</p>
             <p class="txtBottom">빅데이터 공동 플랫폼 구축 및 운영 지원</p>
             <div class="img_box aniBox type_cv delay01 gogo">
               <img src="/static/images/contents/img_bigdata_con03_01.png" alt="">
             </div>
           </li>
           <li class="col_item aniBox type_bot gogo con02">
             <p>활용지원</p>
             <p class="txtBottom">빅데이터 분석·활용 서비스 지원을 위한 상시체계 구축</p>
             <div class="img_box aniBox type_cv delay01 gogo">
               <img src="/static/images/contents/img_bigdata_con03_02.png" alt="">
             </div>
           </li>
           <li class="col_item aniBox type_bot gogo con03">
             <p>수출지원</p>
             <p class="txtBottom">해외 데이터 규제 대응 및 빅데이터 전문인력 양성</p>
             <div class="img_box aniBox type_cv delay01 gogo">
               <img src="/static/images/contents/img_bigdata_con03_03.png" alt="">
             </div>
           </li>
         </ul>
       </div>
     </div>

     <div class="mcSec con_bigdata_04" id="about0104">
       <div class="inner">
         <div class="mainTit aniBox type_bot gogo">
           <h2>담다 플랫폼 서비스 지향점</h2>
           <p>담다 플랫폼은 <strong>실제 비즈니스를 지원, 국내 최초의 상용제품 기반 데이터 얼라이언스</strong>를 기반으로 하며, 데이터 수집에서 분석 · 서비스 지원까지의 <strong>데이터 환류 시스템</strong>을 지향합니다.</p>
         </div>
         <div class="con_bigdata_04_wrap">
           <ul class="con_bigdata_04_list col3">
             <li class="col_item aniBox type_bot gogo">
               <div class="img_box aniBox type_cv delay01 gogo">
                 <img src="/static/images/contents/img_bigdata_con04_01.png" alt="">
               </div>
               <p>연습 없는 실전 적용 플랫폼 구축</p>
               <p class="txtBottom">상용가전 적용을 위한 기술적 완벽성 수요기업 브랜드 이미지 제고</p>
             </li>
             <li class="col_item aniBox type_bot gogo">
               <div class="img_box aniBox type_cv delay01 gogo">
                 <img src="/static/images/contents/img_bigdata_con04_02.png" alt="">
               </div>
               <p>수요기업 지속 발굴 및 밀착 지원</p>
               <p class="txtBottom">지속적인 수요기업 발굴 수요기업 요구반영을 위한 밀착 지원</p>
             </li>
             <li class="col_item aniBox type_bot gogo">
               <div class="img_box aniBox type_cv delay01 gogo">
                 <img src="/static/images/contents/img_bigdata_con04_03.png" alt="">
               </div>
               <p>선순환 지원 플랫폼 운영</p>
               <p class="txtBottom">기업의 동반자가 되는 플랫폼 기업은 고객에게, 고객은 기업에게</p>
             </li>
           </ul>
         </div>
       </div>
     </div>

     <div class="mcSec con_bigdata_05" id="about0105">
       <div class="inner">
         <div class="mainTit aniBox type_bot gogo">
           <h2>담다 서비스 구성</h2>
         </div>
         <div class="con_bigdata_05_wrap">
           <img src="/static/images/contents/img_bigdata_Graphic01.png" alt="" />
         </div>

       </div>
     </div>

     <!-- rightBar -->
     <aside id="rightBar">
       <ul>
         <li class="on">
           <a href="#container">
             <span class="rightbar-bullet-txt"><em>빅데이터 플랫폼</em></span>
             <span class="bullet bullet-01"><i class="material-icons">apps</i></span>
           </a>
         </li>
         <li class="">
           <a href="#about0101">
             <span class="rightbar-bullet-txt"><em>목표</em></span>
             <span class="bullet bullet-02"><i class="material-icons">insert_comment</i></span>
           </a>
         </li>
         <li class="">
           <a href="#about0102">
             <span class="rightbar-bullet-txt"><em>방향 및 추진전략</em></span>
             <span class="bullet bullet-03"><i class="material-icons">dashboard</i></span>
           </a>
         </li>
         <li class="">
           <a href="#about0103">
             <span class="rightbar-bullet-txt"><em>사업범위</em></span>
             <span class="bullet bullet-03"><i class="material-icons">dvr</i></span>
           </a>
         </li>
         <li class="">
           <a href="#about0104">
             <span class="rightbar-bullet-txt"><em>담다플랫폼 서비스지향점</em></span>
             <span class="bullet bullet-03"><i class="material-icons">local_cafe</i></span>
           </a>
         </li>
         <li class="">
           <a href="#about0105">
             <span class="rightbar-bullet-txt"><em>담다 서비스 구성</em></span>
             <span class="bullet bullet-03"><i class="material-icons">account_tree</i></span>
           </a>
         </li>
       </ul>
     </aside>
     <!-- //rightBar -->
   </div>
 </div>
</template>

<script>
export default {
  name: 'About'
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/About.vue